import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useLocation } from "react-router";
import DrawerToggle from "Shared/DrawerToggle";
import styled from "styled-components";
import CellPlusButton from "src/components/MyGarage/TableCompare/Cells/CellPlusButton";
import { EMPTY_VALUE_DASH } from "src/constants";
import { ApplicationStore } from "src/store";
import { localizeCurrencyToWholeNumber } from "src/utils";

const Cell = styled("div")`
    display: flex;
    justify-content: space-between;
    padding: 1em 0.5em 1em 1em;

    ${(props) => props.theme.breakpoints.up("tablet")} {
        padding: 1em;
    }
`;

const StyledDrawerToggle = styled(DrawerToggle)`
    color: inherit;
    height: 100%;
    width: 100%;
`;
interface Props {
    vin: string;
}

const TradeInValue = ({
    tradeInEstimate,
    t,
    vin,
    isOpen,
}: Props & ReturnType<typeof mapStateToProps> & WithTranslation) => {
    const location = useLocation<{ vin?: string }>();
    return (
        <StyledDrawerToggle
            path={{
                pathname:
                    isOpen && location.state?.vin === vin && location.pathname === `/my-garage/trade-in`
                        ? `/my-garage`
                        : `/my-garage/trade-in`,
                ...(isOpen && location.state?.vin === vin && location.pathname === `/my-garage/trade-in`
                    ? {}
                    : { state: { vin } }),
            }}
            title={t("MyGarage.Cells.titles.editTradeIn")}
        >
            <Cell>
                <span>{tradeInEstimate || EMPTY_VALUE_DASH}</span>
                <CellPlusButton />
            </Cell>
        </StyledDrawerToggle>
    );
};

const mapStateToProps = ({ tradeIn, onlineShopper }: ApplicationStore) => {
    return {
        tradeInEstimate: localizeCurrencyToWholeNumber(tradeIn.customer_estimate),
        isOpen: onlineShopper.isDrawerOpen,
    };
};

export default withTranslation()(connect(mapStateToProps)(TradeInValue));
